import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
const FinalCTA = () => {
  return <section className="py-20 bg-burgundy text-white" data-id="element-25">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-26">
        <div className="max-w-3xl mx-auto text-center" data-id="element-27">
          <h2 className="text-3xl md:text-4xl font-bold font-display" data-id="element-28">
            Ready to Focus on Your Food, Not Your Phone?
          </h2>
          <p className="mt-6 text-xl text-cream/90" data-id="element-29">
            Join hundreds of restaurant owners who trust ChefChat with their
            customer communications.
          </p>
          <div className="mt-10 flex justify-center" data-id="element-30">
            <Link to="/signup" className="border-2 border-cream text-cream hover:bg-cream/10 transition-all duration-200 rounded-md font-medium text-lg px-8 py-4 inline-flex items-center justify-center" data-id="element-31">
              Start Free Trial <ArrowRightIcon size={16} className="ml-2" data-id="element-32" />
            </Link>
          </div>
          <p className="mt-6 text-sm text-cream/80" data-id="element-33">
            No credit card required • 14-day free trial • Cancel anytime
          </p>
        </div>
      </div>
    </section>;
};
export default FinalCTA;